import { LowStockProductsColumn } from './LowStockProductsColumn';
import { OrdersToConfirmColumn } from './OrdersToConfirmColumn';
import { QuotesToRespondColumn } from './QuotesToRespondColumn';
import { ReadyToShipColumn } from './ReadyToShipColumn';

export function SellerDashboard() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <LowStockProductsColumn />
      <OrdersToConfirmColumn />
      <ReadyToShipColumn />
      <QuotesToRespondColumn />
    </div>
  );
}
